import { StyleSheet } from 'react-native';

const errorColor = '#ff190c';
const errorFontSize = 12;

export default StyleSheet.create({
  container: {},
  inputContainer: {
    width: '100%',
  },
  labelStyle: {
    color: '#5D5D5D',
    fontSize: 16,
    fontWeight: 'bold',
    marginBottom: 10,
    marginLeft: 10,
  },
  labelStyleStandalone: {
    paddingVertical: 8,
  },
  inputContainerStyle: {
    borderBottomColor: '#DADADE',
  },
  descriptionStyle: {
    borderColor: '#b6b6b6',
    borderWidth: 1,
    borderBottomWidth: 0,
    height: 100,
    paddingHorizontal: 10,
    justifyContent: 'flex-start',
    fontSize: 14,
    color: '#5d5d5d',
  },
  containerDescriptionStyle: {
    paddingHorizontal: 10,
  },
  textDate: {
    fontSize: 16,
    fontWeight: 'bold',
    color: '#D9D8DD',
  },
  splashDate: {
    fontSize: 16,
    fontWeight: 'bold',
    color: '#5d5d5d',
    marginHorizontal: 4,
  },
  dateValue: {
    fontSize: 18,
    color: '#242424',
    flex: 1,
    textAlign: 'center',
  },
  dateContainer: {
    margin: 16,
  },
  dateInputContainer: {
    justifyContent: 'center',
    alignItems: 'center',
    borderBottomColor: '#6d6d6d',
    borderBottomWidth: 0.5,
    height: 40,
  },
  dateValueContainer: {
    flexDirection: 'row',
  },
  error: {
    color: errorColor,
    marginVertical: 0,
    marginLeft: 10,
    fontSize: errorFontSize,
  },
  requiredField: {
    color: errorColor,
    marginVertical: 2,
    marginHorizontal: 20,
    fontSize: errorFontSize,
  },
  requiredFieldDropdown: {
    color: errorColor,
    marginTop: 12,
    marginHorizontal: 20,
    fontSize: errorFontSize,
  },
  requiredFieldCheck: {
    color: errorColor,
    marginTop: -10,
    marginHorizontal: 20,
    fontSize: errorFontSize,
  },
  dropdownError: {
    color: errorColor,
    marginVertical: 10,
    fontSize: errorFontSize,
  },
  dropDownStyle: {
    backgroundColor: '#fafafa',
    zIndex: 10,
    position: 'relative',
  },
  dropdownItemStyle: {
    // justifyContent: 'flex-start',
  },
  dropDownContainer: {
    height: 40,
  },
  dropdownWrapper: {
    zIndex: 1000000000,
    paddingHorizontal: 20,
    position: 'relative',
  },
  checkboxContainer: {
    backgroundColor: 'transparent',
    borderWidth: 0,
    marginLeft: 10,
    paddingLeft: 0,
    marginTop: 0,
    paddingTop: 0,
  },
  checkboxWrapper: {
    paddingHorizontal: 10,
  },
  description: {
    paddingHorizontal: 10,
    marginBottom: 20,
    fontSize: 12,
  },
  inputDynamicStyle: {
    marginTop: 10,
    marginHorizontal: 10,
  },
  inputInputStyle: {
    fontSize: 14,
  },
  labelDynamicStyle: {
    marginBottom: -15,
  },
  titleSection: {
    paddingHorizontal: 10,
  },
  dynamicFormContent: {
    paddingBottom: 100,
  },
  dynamicDescriptionInputContainer: {
    marginHorizontal: 10,
  },
  dynamicFormSpacing: {
    height: 20,
  },
  customPickerLabel: {
    marginLeft: 0,
  },
  termsAndRulesContainer: {
    marginTop: 20,
  },
  termCondition: {
    alignSelf: 'flex-start',
    paddingHorizontal: 20,
    marginBottom: 10,
    fontSize: 12,
    textDecorationLine: 'underline',
  },
});
